import { render } from "./socElement.vue?vue&type=template&id=388b890e&scoped=true"
import script from "./socElement.vue?vue&type=script&lang=js"
export * from "./socElement.vue?vue&type=script&lang=js"

import "./socElement.vue?vue&type=style&index=0&id=388b890e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-388b890e"

export default script